import { memoize } from 'lodash';
import { useMemo } from 'react';
import { useScript } from '../hooks/useScript';
var scriptSrc = 'https://web.judopay.com/js/0.0/judopay.min.js';
var instantiateJudoPay = memoize(function (apiKey, sandbox) {
    return new window.JudoPay(apiKey, sandbox);
});
export function useJudoPay(apiKey, sandbox) {
    var loaded = useScript(scriptSrc);
    return useMemo(function () {
        return (apiKey && loaded && instantiateJudoPay(apiKey, sandbox)) || null;
    }, [apiKey, loaded, sandbox]);
}
//# sourceMappingURL=useJudoPay.js.map